"use client";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { LoginMethodTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { useAtom } from "jotai";
import SigninBtn from "./signin-btn/SigninBtn";
import StudentsDashboardBtn from "./StudentsDashboardBtn";
import { IsTopWinner } from "@/utils/functions/global-constants";
import UserMenu from "../pc-header/helpers/UserMenu";
import LanguageSwitch from "../../toggle-switch/LanguageSwitch";
import useIsClient from "@/hooks/useIsClient";
import BtnGetTheApp from "../../mobile-layout/btn-get-the-app/BtnGetTheApp";

const PcHeaderTail: React.FC<{ showSigninBtn?: boolean }> = ({
  showSigninBtn,
}) => {
  const isCLient = useIsClient();
  const { data: companyData } = useGetCompanyQuery();
  const [isSignedIn] = useAtom(isSignedInAtom);
  const { customer_login_methods, features } =
    companyData?.result.theme?.settings ?? {};
  const isSchool = features?.school;
  if (!isCLient || !companyData?.result) return;
  return (
    <>
      {customer_login_methods !== LoginMethodTypes.none ? (
        !isSignedIn ? (
          <>{showSigninBtn && <SigninBtn />}</>
        ) : (
          <>
            {(isSchool || IsTopWinner(companyData?.result!)) && (
              <StudentsDashboardBtn company={companyData?.result!} />
            )}
            <UserMenu />
          </>
        )
      ) : null}
      {!isSignedIn && <LanguageSwitch />}
      <BtnGetTheApp />
    </>
  );
};

export default PcHeaderTail;
